import { useEditorState } from '@tiptap/react'
import type { Editor } from '@tiptap/react'

interface UseEditorFormattingStateProps {
  editor: Editor | null
}

export interface EditorFormattingState {
  isBold: boolean
  isItalic: boolean
  isStrike: boolean
  isHeading: boolean
  headingLevel: number | null
  isParagraph: boolean
  isBulletList: boolean
  isOrderedList: boolean
  isTaskList: boolean
  isLink: boolean
  isBlockquote: boolean
  isCodeBlock: boolean
}

/**
 * Hook to get current formatting state of the editor
 * Returns active formatting marks and block types
 */
export const useEditorFormattingState = ({ editor }: UseEditorFormattingStateProps) => {
  const editorState = useEditorState({
    editor,
    selector: ({ editor: editorInstance }) => {
      if (!editorInstance) return null
      return {
        isBold: editorInstance.isActive('bold'),
        isItalic: editorInstance.isActive('italic'),
        isStrike: editorInstance.isActive('strike'),
        isHeading: editorInstance.isActive('heading'),
        headingLevel: editorInstance.isActive('heading') ? editorInstance.getAttributes('heading').level : null,
        isParagraph: editorInstance.isActive('paragraph'),
        isBulletList: editorInstance.isActive('bulletList'),
        isOrderedList: editorInstance.isActive('orderedList'),
        isTaskList: editorInstance.isActive('taskList'),
        isLink: editorInstance.isActive('link'),
        isBlockquote: editorInstance.isActive('blockquote'),
        isCodeBlock: editorInstance.isActive('codeBlock'),
      }
    },
  })

  return editorState
}
